/* istanbul ignore file */
import { Show } from 'framework/show';
import { ShowSection, SectionRow, FieldListLayout, ShowPageLayout } from 'framework/ui/layout';
import ViewBudgetPageMenu from 'domain/finance/budget/Show/ViewBudgetPageMenu';
import BudgetEntityHeader from 'domain/finance/budget/shared/BudgetEntityHeader';
import SingleBudgetBreadcrumbs from 'domain/finance/budget/shared/SingleBudgetBreadcrumbs';
import EditBudgetButton from 'domain/finance/budget/shared/button/EditBudgetButton';
import DeleteBudgetButton from 'domain/finance/budget/shared/button/DeleteBudgetButton';
import { DateField, NumberField, TextField } from 'framework/ui/field';
import { EmployeeLinkField } from 'domain/shared/employee';
import { UPDATE_BUDGET, useBudgetService } from 'domain/shared/budget';
import { useBudgetId } from 'domain/finance/budget/shared/useBudgetId';
import { BudgetLinkField, BudgetChildLinkField } from 'domain/shared/budget';

const ViewBudget = () => {
  const id = useBudgetId()!;
  const { getById } = useBudgetService();

  return (
    <Show getDataMethod={() => getById(id)}>
      <ShowPageLayout
        headerButtons={[
          <EditBudgetButton key="edit-budget" icon={<i className="fa fa-edit" />} permissionToCheck={UPDATE_BUDGET} />,
          <DeleteBudgetButton key="delete-budget" />,
        ]}
        menu={<ViewBudgetPageMenu />}
        breadcrumbs={<SingleBudgetBreadcrumbs />}
        entityHeader={<BudgetEntityHeader />}
        hasSeparateSections
      >
        <ShowSection title="Budget Information">
          <SectionRow>
            <TextField label="Name" source="name" />
            <EmployeeLinkField source="ownerId" nameSource="ownerName" label="Owner" />
          </SectionRow>
          <SectionRow>
            <DateField source="periodFrom" label="Start Date" />
            <DateField source="periodTo" label="End Date" />
          </SectionRow>
          <SectionRow>
            <DateField
              source="softPeriodFrom"
              label="Soft Start Date"
              isVisible={(data: any) => !!data.softPeriodFrom}
            />
            <DateField source="softPeriodTo" label="Soft End Date" isVisible={(data: any) => !!data.softPeriodTo} />
          </SectionRow>
          <SectionRow>
            <TextField label="Notes" source="purpose" />
          </SectionRow>
          <SectionRow>
            <FieldListLayout source="childBudgets" label="Child Budgets">
              <BudgetChildLinkField />
            </FieldListLayout>
            <BudgetLinkField label="Parent Budget" source="parentId" nameSource="parentName" />
            <NumberField source="maxFtePercent" label="Max FTE, people" displayZeroValue={false} />
          </SectionRow>
        </ShowSection>
      </ShowPageLayout>
    </Show>
  );
};

export default ViewBudget;
